module.exports = __webpack_public_path__ + "img/keycloak.68d3b7f4.webp";